<template>
  <BaseModal :modalTitle="$t('W: Tilføj skærm')">
    <UiBaseFormVee
      submitOnCtrlEnter
      :errorText="errorText"
      :onSubmit="onSubmit">
      <UiInputTextFieldVee
        name="name"
        :label="$t('W: Titel')"
        :rules="['required']"
        isRequired
        :unit="currentLocale.toUpperCase()"
        v-model="name" />

      <template #buttons>
        <UiBaseButton
          :text="$t('action.create')"
          :isLoading="isLoading"
          :showSaveIcon="showSaveIcon"
          type="submit" />
      </template>
    </UiBaseFormVee>
  </BaseModal>
</template>

<script lang="ts">
import { mapActions, mapState } from 'pinia'
import { useAppStore } from '@/stores/appStore'
import { useDisplayStore } from '@/stores/displayStore'
import { useModalStore } from '@/stores/modalStore'
import { useToast } from '@/globals/typescript/utils/toast'
import { useUnsavedChangesGuard } from '@/composables/useUnsavedChangesGuard'

export default {
  name: 'CreateDisplayModal',

  emits: ['close'],

  data() {
    return {
      unsavedGuard: useUnsavedChangesGuard(),
      name: '',
      isLoading: false,
      showSaveIcon: false,
      errorText: '',
    }
  },

  computed: {
    ...mapState(useAppStore, ['currentLocale', 'defaultMessageSaveIconTime']),
  },

  methods: {
    ...mapActions(useDisplayStore, ['createDisplay']),
    ...mapActions(useModalStore, ['closeTop']),

    async onSubmit(): Promise<void> {
      this.isLoading = true
      this.errorText = ''
      try {
        const id = await this.createDisplay({ [this.currentLocale]: this.name })
        this.showSaveIcon = true
        setTimeout(() => {
          this.showSaveIcon = false
        }, this.defaultMessageSaveIconTime)
        this.unsavedGuard.takeSnapshot()
        useToast().success(this.$t('W: Skærm oprettet'))
        this.closeTop()
        this.$router.push({ name: 'Display', params: { displayID: id } })
      } catch {
        this.errorText = this.$t('error.common.standard')
        useToast().error(this.$t('W: Kunne ikke oprette skærm'))
      } finally {
        this.isLoading = false
      }
    },
  },

  created() {
    // The modal is always the top entry at the moment it is created, so this
    // is its own ModalEntry id — it lets ModalHost tell "the modal I am about
    // to close is dirty" apart from "something underneath it is dirty".
    this.unsavedGuard.register({
      snapshot: () => ({ name: this.name }),
      modalId: useModalStore().top?.id,
    })
  },

  beforeUnmount() {
    this.unsavedGuard.unregister()
  },
}
</script>
